import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import GameDialog from "./Game/Dialog";
import Game from "./Game";
import Guide from "./Guide";
import Leaderboard from "./Leaderboard";
import NotFound from "./NotFound";
import Colophon from "./Colophon";
import AppErrorBoundary from "./ErrorBoundary/ErrorBoundary";
import MediaTest from "./MediaTest";
import Unsupported from "./Unsupported";

import "./App.scss";

function App() {
  useEffect(() => {
    setVH();
    window.addEventListener("orientationchange", setVH);
    return () => {
      window.removeEventListener("orientationchange", setVH);
    };
  }, []);

  return (
    <div
      className={`app-blackbox-ui ${process.env.NODE_ENV} ${process.env.REACT_APP_NAME}-${process.env.REACT_APP_VERSION}`}
    >
      {window.CSS.supports("display", "grid") ? (
        <Router>
          <ToastContainer hideProgressBar transition={Bounce} />
          <div className="app">
            <AppErrorBoundary>
              <Switch>
                <Route exact path="/" component={GameDialog} />
                <Route exact path="/game/:nonce" component={Game} />
                <Route path="/guide" component={Guide} />
                <Route path="/colophon" component={Colophon} />
                <Route path="/leaderboard" component={Leaderboard} />
                <Route path="/404" component={NotFound} />
                <Route path="/media" component={MediaTest} />
                <Route path="/testing" component={Unsupported} />
                <Route component={NotFound} />
              </Switch>
            </AppErrorBoundary>
          </div>
        </Router>
      ) : (
        <Unsupported />
      )}
    </div>
  );
}

function setVH() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

export default App;
